import { ITag } from "@app/interfaces/ITag";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { ResourceAllocation } from "@enums/ResourceType";
import { SortType } from "@enums/SortType";
import { ITagFilter } from "@interfaces/filters/ITagFilter";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { TagsService } from "@services/tags.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import "./tagsResourceFilter.scss";

interface IComponentBindings {
    selectedTag: ITag;
    tagId: number;
    resourceType: string;
}

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<ITagFilter>{
    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "Tags";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    resourceType: string;

    tags: ITag[] = [];

    loading: boolean;

    tagId: number;
    selectedTag: ITag;

    previousFilter: ITagFilter;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<ITag>[];

    onChange: (args: { filter: ITagFilter }) => void;

    static $inject = ["$rootScope", "$element", "$timeout", "tagsService", "translationService"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        public readonly $element: HTMLElement,
        private readonly $timeout: angular.ITimeoutService,
        private readonly tagsService: TagsService,
        private readonly translationService: TranslationService    ) {
    }

    $onInit() {
        this.parent.registerFilter(this);
        this.createTableHeaders();        
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();

        if (onChangesObj['tagId']) {
            this.selectedTag = null;
            this.getTags();
        }
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.getTags();
        }
    }

    clearFilter() {
        this.selectedTag = null;
        this.tagId = null;

        this.updateFilterLabel();
    }

    selectedTagChanged(tag: ITag) {
        this.tagId = null;

        if (this.selectedTag == tag) {
            this.selectedTag = null;
        }
        else {
            this.selectedTag = tag;
        }

        this.updateFilterLabel();
        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    createFilterObject(): ITagFilter {
        return {
            tag: this.selectedTag
        };
    }   

    // ------------------

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.translationService.t('filters.tagsResourceFilter.tag'), sortable: true, sortType: SortType.Number },
            { title: this.translationService.t('filters.tagsResourceFilter.resourceType'), alignRight: true },
        ];
    }

    private getTags() {       
        this.loading = true;
        this.tags = [];

        this.tagsService.getTags().then(tags => {
            if (this.resourceType) {
                this.tags = tags.filter(tag => tag.ResourceAllocation == ResourceAllocation[this.resourceType] || tag.ResourceAllocation == ResourceAllocation.All);
            }
            else {
                this.tags = tags;
            }

        }).finally(() => {
            this.createTableRows();
            this.updateFilterLabel();
            this.loading = false;
        });
    }

    private updateFilterLabel() {
        this.filterLabel = this.translationService.t('filters.tagsResourceFilter.tags');
        this.filterIcon = "local_offer";

        if (this.tags && this.tagId) {
            this.selectedTag = this.tags.find(tag => tag.Id === this.tagId);
        }

        if (this.selectedTag) {
            this.filterLabel = this.selectedTag.Name;
        }

        this.isDirty = !!this.selectedTag;
    }

    private createTableRows() {
        this.tableRows = [];

        this.tags.forEach(tag => {
            this.tableRows.push({
                data: tag,
                cells: this.createTableCells(tag)
            });
        });
    }

    private createTableCells(tag: ITag): IVeriTableRowCell[] {
        var resourceType = ResourceAllocation[tag.ResourceAllocation];

        const cells: IVeriTableRowCell[] = [
            {
                contents: `<div class="tags-filter" style="border-left-color:${tag.ColourObject ? tag.ColourObject.solidColour : 'Grey'}; margin: -10px -13px;">
                              <span style="margin-left: 10px;">${tag.Name}</span>
                           </div>`,
                data: tag,
                sortData: tag.Name + ResourceAllocation[tag.ResourceAllocation],
                exportData: tag.Name
            },

            { contents: resourceType, className: 'text-muted' }
        ];

        return cells;
    }
}

export class TagsResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            selectedTag: "<tag",
            tagId: "<?",
            onChange: "&",
            resourceType: "<?"
        };

        this.require = {
            parent: "^newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./tagsResourceFilter.html");
    }
}
